module.exports = __webpack_public_path__ + "static/06_VISA-2dbdd57cc4b6d65b497ad8fbf7fa7fbc.png";